import React from 'react';
import { Phone, CheckCircle, Award, Wrench } from 'lucide-react';
export function FarmEquipmentRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6769">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6770">
        <div className="container mx-auto px-4" data-id="element-6771">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6772">
            Farm Equipment Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6773">
            Expert Tractor and Farm Equipment Service
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6774">
        <div className="max-w-6xl mx-auto" data-id="element-6775">
          {/* A Piece of Mind */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6776">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-6777">
              A Piece Of Mind
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-6778">
              <div className="flex items-center justify-center" data-id="element-6779">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fgpsfarm_800big.jpg&site=1986&w=195&h=281&user=1617&opt=w3" alt="Farm equipment GPS" className="rounded-lg shadow-md" style={{
                width: '195px',
                height: '281px'
              }} data-id="element-6780" />
              </div>

              <div data-id="element-6781">
                <p className="text-lg text-gray-700 mb-4" data-id="element-6782">
                  <strong data-id="element-6783">
                    <u data-id="element-6784">At Garrett Auto & Truck Service we understand</u>
                  </strong>{' '}
                  that your farm equipment is one of your most important tools
                  for all of your work needs. Our full-service tractor repair
                  shop and mechanical team will work on your tractor with expert
                  care with affordable, honest prices.
                </p>

                <p className="text-lg text-gray-700 mb-4" data-id="element-6785">
                  We'll bring the best performance possible out of your tractor
                  with our complete tune-ups. The convenience and flexibility of
                  our shop service provides you with the professional tractor
                  care you need with no-hassle repairs.
                </p>

                <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4" data-id="element-6786">
                  <p className="text-lg text-gray-800" data-id="element-6787">
                    <strong data-id="element-6788">
                      Best of all we <em data-id="element-6789">warranty</em> all of our work 100%.
                    </strong>
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4" data-id="element-6790">
                  <p className="text-gray-800" data-id="element-6791">
                    <em data-id="element-6792">
                      <u data-id="element-6793">
                        Our service is backed by our personal pledge of customer
                        satisfaction
                      </u>
                      .
                    </em>
                  </p>
                </div>

                <p className="text-gray-700" data-id="element-6794">
                  We will provide you, our customer, with outstanding
                  professional courtesy and service. And we will stand behind
                  our workmanship.
                </p>
              </div>
            </div>
          </div>

          {/* Onsite Repairs & Maintenance */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-6795">
            <h2 className="text-4xl font-bold flex items-center justify-center" data-id="element-6796">
              <Wrench className="mr-3" size={40} data-id="element-6797" />
              Onsite Repairs & Maintenance
            </h2>
          </div>

          {/* Services Grid */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6798">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-6799">
              {/* Services List */}
              <div data-id="element-6800">
                <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-6801">
                  Complete Farm Equipment Services
                </h3>

                <div className="space-y-3" data-id="element-6802">
                  <div className="flex items-start" data-id="element-6803">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6804" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6805">
                      Engine Lights
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6806">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6807" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6808">
                      Diagnostics
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6809">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6810" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6811">
                      Spark Plugs
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6812">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6813" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6814">
                      Hydraulics
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6815">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6816" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6817">
                      Wiring
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6818">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6819" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6820">
                      Clutches
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6821">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6822" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6823">
                      Tractor/Farm Equipment (Trans)
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6824">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6825" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6826">
                      Preventative (Maint)
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6827">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6828" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6829">
                      Air-Conditioning
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6830">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6831" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6832">
                      Water Pumps
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6833">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6834" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6835">
                      Brake Service
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6836">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6837" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6838">
                      Major and Minor Repair
                    </span>
                  </div>

                  <div className="flex items-start" data-id="element-6839">
                    <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-6840" />
                    <span className="text-lg text-gray-700 font-semibold" data-id="element-6841">
                      Attachments for Behind Tractor
                    </span>
                  </div>
                </div>
              </div>

              {/* Tractor Image */}
              <div className="flex items-center justify-center" data-id="element-6842">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Ftractor2.jpg&site=1986&w=467&h=355&user=1617&opt=w3" alt="Tractor repair" className="rounded-lg shadow-md w-full h-auto" style={{
                maxWidth: '467px',
                maxHeight: '355px'
              }} data-id="element-6843" />
              </div>
            </div>
          </div>

          {/* Our Commitment */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6844">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6845">
              Our Commitment to You
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-6846">
              <div className="text-center" data-id="element-6847">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6848">
                  <Award className="text-blue-600" size={32} data-id="element-6849" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6850">
                  100% Warranty
                </h3>
                <p className="text-gray-700" data-id="element-6851">
                  All of our work is backed by our complete warranty
                </p>
              </div>

              <div className="text-center" data-id="element-6852">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6853">
                  <CheckCircle className="text-green-600" size={32} data-id="element-6854" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6855">
                  Customer Satisfaction
                </h3>
                <p className="text-gray-700" data-id="element-6856">
                  Personal pledge of outstanding service and courtesy
                </p>
              </div>

              <div className="text-center" data-id="element-6857">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6858">
                  <Wrench className="text-purple-600" size={32} data-id="element-6859" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6860">
                  Expert Care
                </h3>
                <p className="text-gray-700" data-id="element-6861">
                  Affordable, honest prices with professional workmanship
                </p>
              </div>
            </div>
          </div>

          {/* Service Categories */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6862">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6863">
              What We Service
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-6864">
              <div className="bg-green-50 rounded-lg p-6" data-id="element-6865">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6866">
                  Engine & Performance
                </h3>
                <ul className="space-y-2" data-id="element-6867">
                  <li className="flex items-start" data-id="element-6868">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6869" />
                    <span className="text-gray-700" data-id="element-6870">
                      Engine diagnostics and lights
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6871">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6872" />
                    <span className="text-gray-700" data-id="element-6873">
                      Spark plugs and tune-ups
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6874">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6875" />
                    <span className="text-gray-700" data-id="element-6876">
                      Water pumps and cooling systems
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6877">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6878" />
                    <span className="text-gray-700" data-id="element-6879">
                      Air-conditioning service
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-6880">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6881">
                  Mechanical Systems
                </h3>
                <ul className="space-y-2" data-id="element-6882">
                  <li className="flex items-start" data-id="element-6883">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6884" />
                    <span className="text-gray-700" data-id="element-6885">Hydraulic systems</span>
                  </li>
                  <li className="flex items-start" data-id="element-6886">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6887" />
                    <span className="text-gray-700" data-id="element-6888">
                      Clutches and transmissions
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6889">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6890" />
                    <span className="text-gray-700" data-id="element-6891">
                      Brake service and repair
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6892">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6893" />
                    <span className="text-gray-700" data-id="element-6894">
                      Electrical wiring systems
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-6895">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6896">
                  Maintenance & Repair
                </h3>
                <ul className="space-y-2" data-id="element-6897">
                  <li className="flex items-start" data-id="element-6898">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6899" />
                    <span className="text-gray-700" data-id="element-6900">
                      Preventative maintenance programs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6901">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6902" />
                    <span className="text-gray-700" data-id="element-6903">
                      Major mechanical repairs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6904">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6905" />
                    <span className="text-gray-700" data-id="element-6906">
                      Minor mechanical repairs
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6907">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6908" />
                    <span className="text-gray-700" data-id="element-6909">Complete diagnostics</span>
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-6910">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-6911">
                  Equipment & Attachments
                </h3>
                <ul className="space-y-2" data-id="element-6912">
                  <li className="flex items-start" data-id="element-6913">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6914" />
                    <span className="text-gray-700" data-id="element-6915">
                      Tractor attachments service
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6916">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6917" />
                    <span className="text-gray-700" data-id="element-6918">
                      Farm equipment transmissions
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6919">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6920" />
                    <span className="text-gray-700" data-id="element-6921">
                      Onsite repair services
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-6922">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6923" />
                    <span className="text-gray-700" data-id="element-6924">
                      No-hassle shop service
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6925">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6926">
              Expert Farm Equipment & Tractor Repair
            </h2>
            <p className="text-xl mb-6" data-id="element-6927">
              Affordable, honest service with 100% warranty on all work
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6928">
              <Phone className="mr-3" size={24} data-id="element-6929" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6930">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}